import {gsap} from "../LibrariesImport";
export default class BlockHistory {
	static init() {
		let blocks = document.querySelectorAll('.block-history');
		let mm = gsap.matchMedia();

		mm.add("(min-width: 992px)", () => {
			blocks.forEach(block => {
				const swiperHistory = block.querySelector('.swiper-history');
				const swiperThumbs = block.querySelector('.swiper-thumbs');
				const swiperThumb = new Swiper(swiperThumbs, {
					slidesPerView: swiperThumbs.querySelectorAll('.swiper-slide').length,
					freeMode: true,
					watchSlidesProgress: true,
				});
				new Swiper(swiperHistory, {
					slidesPerView: "1",
					grabCursor: true,
					spaceBetween: 40,
					thumbs: {
						swiper: swiperThumb,
					},
					on: {
						slideChange: function () {
							swiperThumb.slides.forEach(slide => {
								slide.classList.remove('swiper-slide-past');
							});
							for (let i = 0; i < this.activeIndex; i++) {
								swiperThumb.slides[i].classList.add('swiper-slide-past');
							}
						}
					}
				});
			});
		});
	}
}
